import "./observability/sentry/instrument"; // FIRST. Before React, before store.
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Provider } from "react-redux";
import SentryErrorBoundary from "./observability/sentry/SentryErrorBoundary";
import { makeStore } from "./redux/store/index.ts";
import {
  amplitude,
  AMPLITUDE_LOG_LEVEL,
} from "./utils/amplitude/amplitude.ts";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";

const amplitudeApiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;

amplitude?.init(amplitudeApiKey, {
  logLevel: AMPLITUDE_LOG_LEVEL,
  autocapture: {
    pageViews: {
      eventType: "page_viewed",
    },
  },
  defaultTracking: {
    sessions: true,
  },
});

const sessionReplayTracking = sessionReplayPlugin({
  sampleRate: 1,
});

amplitude.add(sessionReplayTracking);

const store = makeStore();

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <SentryErrorBoundary>
      <App />
    </SentryErrorBoundary>
  </Provider>
);
